import * as Moment from 'moment';
import { IParser } from '../interfaces';

const POSSIBLE_FORMATS = [
  'YYYY-MM-DDTHH:mm:ss',
  'DD-MM-YYYY',
  'YYYY-MM-DDTHH:mm:ssZ',
  'YYYY-MM-DD'
];

export class DateParser implements IParser {
  parse(input: unknown, utc: boolean = false): Date {
    if (input === '0001-01-01T00:00:00') {
      return null;
    }

    let validDate: Date = null;

    // use 'some' to break when found
    POSSIBLE_FORMATS.some(format => {
      const momentDate = Moment(input, format, true);
      if (momentDate.isValid()) {
        validDate = momentDate.toDate();
        return true;
      }

      return false;
    });

    if(utc) {
      validDate = this.convertLocalToUTC(validDate);
    }
    return validDate;
  }

  convertLocalToUTC(localDate: Date): Date {
    const timezoneOffset = localDate.getTimezoneOffset(); // in minutes
  
    // Create a new Date object by adjusting for the timezone difference
    const utc = new Date(localDate.getTime() - timezoneOffset * 60000); // Convert minutes to milliseconds
  
    return utc;
  }
}
